import React, { useContext } from 'react';
import { GroupBase } from 'react-select';
import { IOptionBase, ISelectValueContainerProps } from '../models';
import { classnames } from '@src/utils/classnames';

import styled from './SelectValueContainer.module.scss';
import { SelectContext } from '../context';
import { Text } from '@src/atoms/Text';

export const SelectValueContainer = <
  OptionType extends IOptionBase,
  GroupType extends GroupBase<OptionType>,
  IsMulti extends boolean,
>({
  children,
  innerProps,
  selectProps,
}: ISelectValueContainerProps<OptionType, GroupType, IsMulti>) => {
  const { classNamePrefix, isIndicator, staticLabel, menuIsOpen } = selectProps;
  const { postIcon, size = 'md' } = useContext(SelectContext);
  const classes = classnames(styled.root, classNamePrefix);

  return (
    <div
      className={classes}
      data-indicator={isIndicator}
      data-size={size}
      data-post-icon={!!postIcon}
      data-id={`${selectProps['data-id']}_valueContainer`}
      {...innerProps}
      data-elem="select-value-container"
    >
      {staticLabel && !menuIsOpen && (
        <Text id="staticLabel" size={'secondary'}>
          {staticLabel}
        </Text>
      )}

      {children}
    </div>
  );
};
